import { BillingProfileId, type ExternalCharge } from '@mntn-dev/domain-types'

import { MockModel } from './mock-model.ts'

export const MockExternalCharge = MockModel<ExternalCharge>(
  ({
    billingProfileId = BillingProfileId(),
    externalChargeId = 0,
    amount = 0,
    status = 'failed',
  }) =>
    ({
      billingProfileId,
      externalChargeId,
      amount,
      status,
    }) satisfies ExternalCharge
)
